import React, { useState } from "react";
import Logo from "../../img/loginLogo.png";
import { Formik, Form } from "formik";
import {
  validationSchema,
  initialValue,
} from "../../validation/LoginValidation";
import Captcha from "../../components/Captcha";
import {
  Button,
  Grid,
  Typography,
  CssBaseline,
  InputAdornment,
  Link,
  Fade,
  CircularProgress,
} from "@material-ui/core";
import TextField from "../../components/TextField";
import { connect } from "react-redux";
import { setAuthToken } from "../../redux/Login/LoginActions";
import { useHistory } from "react-router-dom";
import { Visibility } from "@material-ui/icons";
import Store from "../../redux/Store";
import { authUnauthorizedMessage } from "../../redux/Login/LoginActionCreators";

const Login = ({ authError, showCaptcha, loading }) => {
  const history = useHistory();
  const [showPass, setShowPass] = useState(true);
  React.useEffect(() => {
    Store.dispatch(authUnauthorizedMessage(null));
  }, []);

  return (
    <Formik
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, submitProps) => {
        setAuthToken(values);
      }}
      validateOnMount
    >
      {(formik) => {
        return (
          <Form>
            <CssBaseline>
              <Fade in={true} timeout={500}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{ height: "100vh", backgroundColor: "#F2F2F6" }}
                >
                  <Grid
                    container
                    item
                    justifyContent="center"
                    alignItems="center"
                    direction="column"
                    spacing={4}
                    xs={10}
                    sm={6}
                    md={5}
                    lg={4}
                    xl={3}
                    style={{
                      backgroundColor: "white",
                      borderRadius: "20px",
                      boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                      paddingTop: "51px",
                      paddingBottom: "51px",
                    }}
                  >
                    <Grid
                      item
                      container
                      md={10}
                      xs={12}
                      justifyContent="center"
                      spacing={3}
                      style={{ margin: "auto" }}
                    >
                      <Grid item xs={12} container justifyContent="center">
                        <img src={Logo} alt="logo" />
                      </Grid>

                      <Grid item>
                        <Typography color="textSecondary" variant="subtitle1">
                          برای ورود شماره موبایل یا ایمیل خود را وارد کنید
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <TextField name="username" label="شماره موبایل/ایمیل" />
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <TextField
                          name="password"
                          label="رمز عبور"
                          type={showPass ? "password" : null}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Visibility
                                  color="primary"
                                  fontSize="small"
                                  onClick={() => setShowPass(!showPass)}
                                  style={{ cursor: "pointer" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography color="secondary" variant="subtitle2">
                          {authError}
                        </Typography>
                        <Link
                          onClick={() => history.push("/login/getCode")}
                          style={{
                            cursor: "pointer",
                            textDecoration: "none",
                          }}
                        >
                          رمز خود را فراموش کرده ام
                        </Link>
                      </Grid>

                      {showCaptcha !== false ? (
                        <Grid item xs={12} container justifyContent="center">
                          <Captcha />
                        </Grid>
                      ) : null}
                      <Grid item xs={12} container justifyContent="center">
                        <Button
                          onClick={() => {
                            history.push("/register");
                          }}
                          color="primary"
                          style={{ fontWeight: "bold" }}
                        >
                          ثبت نام
                        </Button>
                      </Grid>
                      <Grid item xs={12} container>
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          type="submit"
                          disabled={!formik.isValid || loading}
                        >
                          {!loading ? (
                            "تایید"
                          ) : (
                            <CircularProgress
                              style={{
                                color: "white",
                                height: 24,
                                width: 24,
                              }}
                            />
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Fade>
            </CssBaseline>
          </Form>
        );
      }}
    </Formik>
  );
};
const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { authError, showCaptcha, captchaCode, loading } = loginReducer;
  return { authError, showCaptcha, captchaCode, loading };
};

export default connect(mapStateToProps)(Login);
